export enum SessionType {
  VIDEO = 'video',
  IN_PERSON = 'in_person',
  NO_PREFERENCE = 'mix'
}
